<span class="reasonText" [ngSwitch]="reason">
  <span *ngSwitchCase="'SEED'"                i18n="@@JoinReasonSeed">The item this group formed around</span>
  <!--
    Widened for planner 1.3.0, which added binding, interior, paper and
    lamination to the IDENTICAL test. The old wording listed five things while
    the code checked nine - not wrong, but incomplete, and "everything matches"
    printed above a row showing a different paper stock would have been exactly
    the misleading-by-omission problem IDENTICAL was introduced to fix.

    The id is UNCHANGED, and the English in all 21 bundles was updated to match
    in the same change. That second half is not optional: sync-i18n-strings
    ADDS rows but never REFRESHES them, so editing this line alone would leave
    every bundle serving the old sentence and the screen would not change.
  -->
  <span *ngSwitchCase="'IDENTICAL'"           i18n="@@JoinReasonIdentical">Everything matches &mdash; title, author, both PDFs, page count, size and print specification</span>
  <span *ngSwitchCase="'WORK_ID_EXISTING'"    i18n="@@JoinReasonWorkIdExisting">Already shares a Project</span>
  <span *ngSwitchCase="'ISBN_EXACT'"          i18n="@@JoinReasonIsbnExact">Same ISBN</span>
  <span *ngSwitchCase="'SFBN_EXACT'"          i18n="@@JoinReasonSfbnExact">Same SFBN</span>
  <span *ngSwitchCase="'BODY_RESOURCE_EXACT'" i18n="@@JoinReasonBodyResourceExact">Same interior PDF, page count and trim size</span>
  <span *ngSwitchCase="'BODY_RESOURCE_TITLE'" i18n="@@JoinReasonBodyResourceTitle">Same interior PDF and same title</span>
  <span *ngSwitchCase="'BODY_RESOURCE_ONLY'"  i18n="@@JoinReasonBodyResourceOnly">Same interior PDF, but the titles differ</span>
  <span *ngSwitchCase="'TITLE_AUTHOR_PAGES'"  i18n="@@JoinReasonTitleAuthorPages">Same title, author and page count</span>
  <span *ngSwitchCase="'TITLE_AUTHOR'"        i18n="@@JoinReasonTitleAuthor">Same title and author</span>
  <span *ngSwitchCase="'TITLE_EXACT'"         i18n="@@JoinReasonTitleExact">Same title</span>
  <span *ngSwitchCase="'TITLE_CORE'"          i18n="@@JoinReasonTitleCore">Nearly the same title</span>
  <span *ngSwitchCase="'COVER_RESOURCE'"      i18n="@@JoinReasonCoverResource">Same cover PDF</span>
  <span *ngSwitchCase="'TITLE_FUZZY'"         i18n="@@JoinReasonTitleFuzzy">A similar title</span>
  <!--
    An unrecognised code.

    This path is EXPECTED, not hypothetical: the server confirmed on
    2026-10-23 that the vocabulary will gain codes when the planner is
    written, because that is where it gets finalised rather than imagined.

    It used to render the bare code, which put an untranslated identifier
    (`TITLE_SUBTITLE_MATCH`) into a sentence a customer is being asked to act
    on. Rendering nothing would be worse still -- a blank reads as "there is
    no reason for this item to be here". So: a translated sentence that admits
    the gap, with the code kept beside it and marked as technical, because the
    code is what someone needs to quote for us to close the vocabulary gap.
  -->
  <span *ngSwitchDefault>
    <span i18n="@@JoinReasonUnknown">Matched, but this version cannot explain how</span>
    <span class="reasonCode">{{ reason }}</span>
  </span>
</span>
<span *ngIf="hasTarget" class="reasonTarget">
  <span i18n="@@MappingMatchedWith">matched with</span>
  <span class="reasonTargetName">{{ joinedToLabel }}</span>
</span>
<span *ngIf="corroborationOnly" class="reasonNote" i18n="@@MappingCorroborationOnly">(supporting evidence only &mdash; this on its own never groups items)</span>
